<template>
	<div :class="{ 'col-12 col-lg-4': !field.parent_id, 'col-12': field.parent_id}">
		<div
			class="form-group"
		>
			<label
				:for="'DateField' + field.form_field_id + personNumber"
				class="d-block col-form-label-sm"
			>
				{{ field.name }}
			</label>
			<the-mask
				:id="'DateField' + field.form_field_id + personNumber"
				:value="value"
				:mask="mask"
				placeholder="дд.мм.гггг"
				:masked="true"
				class="form-control rounded-0"
				:class="{'is-invalid': isValidate === false, 'is-valid': isValidate}"
				@input="$emit('input', $event)"
				@change.native="$emit('change', $event)"
				@focus.native="$emit('focus', $event)"
				@blur.native="onBlur"
			/>
			<div v-if="isValidate === false" class="error">
				Заполните поле корректно
			</div>
		</div>
	</div>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import moment from '@/utils/moment';

export default {
	name: 'DateField',
	components: {
		TheMask,
	},
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { default: null },
		personNumber: { default: null },
	},
	data() {
		return {
			isValidate: null,
			mask: '##.##.####',
		};
	},
	computed: {
		isValidDate() {
			return this.value?.length === this.mask.length && moment(this.value, 'DD.MM.YYYY').isValid();
		},
	},
	methods: {
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 *
		 * Если какие-то поля имеют дополнительную валидацию - то они могут изменить true валидность на false.
		 * Но не могут изменить false на true. Т.к. валидация, приходящая из бэка - более приоритетная.
		 * И не могут изменить undefined на false. Например, если телефон не обязателен, а заполнен неправильно - он все равно true.
		 *
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			if (!this.field.validations) {
				if (this.isValidDate) this.isValidate = true;
				return true;
			}

			const isValid = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			if (isValid === false) this.isValidate = false;
			if (isValid === true && this.isValidDate === true) this.isValidate = true;
			if (isValid === true && this.isValidDate === false) this.isValidate = false;
			if (typeof isValid === 'undefined' || isValid === null) this.isValidate = true;

			return this.isValidate;
		},
		approveValidation() {
			this.isValidate = true;
		},
		onBlur() {
			this.$emit('blur', this.value, this.isValidDate);
		},
	},

};
</script>

<style scoped>
.error {
	width: 100%;
	margin-top: 0.25rem;
	font-size: 80%;
	color: #dc3545;
}
</style>
